import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AssessmentAnswerInterface, AssessmentQuestionInterface } from 'app/assessment/models';
import { DynamicQuestionComponent } from 'app/assessment/questions/dynamic-question-content/dynamic-question.component';
import { getDeepCopyOfObject } from 'app/shared/utilities/utility-methods.utility';

@Component({
  selector: 'cz-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
})
export class TextInputComponent extends DynamicQuestionComponent implements OnInit {
  @Input() public readonly type: string;
  @Input() public readonly question: AssessmentQuestionInterface;
  @Input() public readonly form: FormGroup;
  @Input() public readonly imagePath: string;
  @Input() public readonly parentQuestion: AssessmentQuestionInterface;
  @Input() public readonly readOnly: boolean;

  constructor() {
    super();
  }

  public ngOnInit():void {
  }

  public isFieldValid(field: string): boolean {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  public displayFieldCss(field: string): {} {
    return {
      'error-msg': this.isFieldValid(field),
    };
  }

  public onKeyPress(value: string, formGroupName: string, formControlName: string, answer: AssessmentAnswerInterface): void {
    const formGroup: any = this.form.controls[this.type];
    const updatedAnswer: AssessmentAnswerInterface = getDeepCopyOfObject(answer);
    updatedAnswer.text = value;

    if (formGroupName) {
      formGroup.controls[formGroupName].controls[formControlName].setValue(updatedAnswer);
      return;
    }

    formGroup.controls[formControlName].setValue(updatedAnswer);
  }
}
